var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('ModalInputNickname',{attrs:{"show":!_vm.hasNickname},on:{"close":_vm.close}}),_c('ModalRankTest',{attrs:{"show":_vm.hasNickname && !_vm.hasRank},on:{"close":function($event){return _vm.close(true)}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }